import { render, staticRenderFns } from "./JuegosNavar.vue?vue&type=template&id=6ff1d028&scoped=true"
import script from "./JuegosNavar.vue?vue&type=script&lang=js"
export * from "./JuegosNavar.vue?vue&type=script&lang=js"
import style0 from "./JuegosNavar.vue?vue&type=style&index=0&id=6ff1d028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff1d028",
  null
  
)

export default component.exports